import navBar from '../../shared-components/nav-bar/index.mjs';
import footer from '../../shared-components/custom-footer/index.mjs';
import signUp from '../../shared-components/sign-up/index.mjs';

// Lightbox modal logic
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('photo-modal');
  const modalImg = document.getElementById('photo-modal-img');
  const closeBtn = document.querySelector('.photo-modal-close');
  const blur = document.querySelector('.photo-modal-blur');
  const timelineImages = document.querySelectorAll('.timeline-item img');

  timelineImages.forEach((img) => {
    img.style.cursor = 'pointer';
    img.addEventListener('click', function () {
      modal.classList.add('active');
      modalImg.src = this.src;
      modalImg.alt = this.alt;
    });
  });

  function closeModal() {
    modal.classList.remove('active');
    modalImg.removeAttribute('src');
    modalImg.alt = '';
  }

  closeBtn.addEventListener('click', closeModal);
  blur.addEventListener('click', closeModal);

  // Close with ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
});
